<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.26554 1.63363C3.34608 1.41597 3.65392 1.41597 3.73446 1.63363L4.13533 2.71696C4.16065 2.78539 4.21461 2.83935 4.28304 2.86467L5.36637 3.26554C5.58403 3.34608 5.58403 3.65392 5.36637 3.73446L4.28304 4.13533C4.21461 4.16065 4.16065 4.21461 4.13533 4.28304L3.73446 5.36637C3.65392 5.58403 3.34608 5.58403 3.26554 5.36637L2.86467 4.28304C2.83935 4.21461 2.78539 4.16065 2.71696 4.13533L1.63363 3.73446C1.41597 3.65392 1.41597 3.34608 1.63363 3.26554L2.71696 2.86467C2.78539 2.83935 2.83935 2.78539 2.86467 2.71696L3.26554 1.63363Z"
      :fill="color"
    />
    <path
      d="M5.26554 8.63363C5.34608 8.41597 5.65392 8.41597 5.73446 8.63363L6.40542 10.4469C6.43075 10.5153 6.4847 10.5693 6.55313 10.5946L8.36637 11.2655C8.58403 11.3461 8.58403 11.6539 8.36637 11.7345L6.55313 12.4054C6.4847 12.4307 6.43075 12.4847 6.40542 12.5531L5.73446 14.3664C5.65392 14.584 5.34608 14.584 5.26554 14.3664L4.59458 12.5531C4.56925 12.4847 4.5153 12.4307 4.44687 12.4054L2.63363 11.7345C2.41597 11.6539 2.41597 11.3461 2.63363 11.2655L4.44687 10.5946C4.5153 10.5693 4.56925 10.5153 4.59458 10.4469L5.26554 8.63363Z"
      :fill="color"
    />
    <path
      d="M9.76554 1.63363C9.84608 1.41597 10.1539 1.41597 10.2345 1.63363L11.3106 4.54174C11.3359 4.61017 11.3898 4.66412 11.4583 4.68944L14.3664 5.76554C14.584 5.84608 14.584 6.15392 14.3664 6.23446L11.4583 7.31056C11.3898 7.33588 11.3359 7.38983 11.3106 7.45826L10.2345 10.3664C10.1539 10.584 9.84608 10.584 9.76554 10.3664L8.68944 7.45826C8.66412 7.38983 8.61017 7.33588 8.54174 7.31056L5.63363 6.23446C5.41597 6.15392 5.41597 5.84608 5.63363 5.76554L8.54174 4.68944C8.61017 4.66412 8.66412 4.61017 8.68944 4.54174L9.76554 1.63363Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'AIIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
